import React, {useRef, useState} from "react";
import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import {RiFileDownloadLine} from "react-icons/ri";
import { CSVLink } from "react-csv";

export default function ExportToExcelButton(props) {
    const buttonRef = useRef();
    const [showTooltip, setShowTooltip] = useState(false);
    const data = props.data;
    const title = props.title || 'Wint report';

    return (
        <OverlayTrigger
            key={'tooltip'}
            placement={'left'}
            overlay={
                <Tooltip id={`tooltip-top`}>
                    Export to Excel
                </Tooltip>
            }
        >
            {props.csvData ?
                <CSVLink data={props?.csvData} filename={`${title}.csv`}>
                    <Button ref={buttonRef} variant={'aqua'} className={'btn-round btn-export-to-excel'}>
                        <RiFileDownloadLine/>
                    </Button>
                </CSVLink>
                :
                <Button ref={buttonRef} variant={'aqua'} className={'btn-round btn-export-to-excel'}>
                    <RiFileDownloadLine/>
                </Button>
            }
        </OverlayTrigger>
    )
}